module.exports = __webpack_public_path__ + "img/yizuofei.9a18a371.png";